export const environment = {
  production: true,
  apiUrl: 'https://api.sca.ge/api/',
  defaultDoamin: 'https://sca.ge/',

};
